import { jsx as _jsx } from "react/jsx-runtime";
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
const bgColor = ({ palette }) => (palette.mode === 'light' ? grey[400] : grey[800]);
const SpeechBubbleStyled = styled(Typography, {
    shouldForwardProp: (prop) => !['highlighted'].includes(prop)
}) `
    background-color: ${({ theme, highlighted }) => (highlighted ? theme.palette.primary.main : bgColor(theme))};
    color: ${({ theme, highlighted }) => (highlighted ? theme.palette.common.white : theme.palette.text.primary)};
    margin-right: 50px;
    padding: 11px 20px;
    border-radius: 20px;
    word-break: break-word;
    line-height: 1.4;
    position: relative;

    &:before {
        border-bottom-right-radius: 12px;
        border-left: 14px solid
            ${({ theme, highlighted }) => (highlighted ? theme.palette.primary.main : bgColor(theme))};
        left: -5px;
    }

    &:after {
        background-color: ${({ theme }) => theme.palette.background.default};
        border-bottom-right-radius: 8px 24px;
        left: -5px;
        width: 5px;
    }

    &:before,
    &:after {
        bottom: -1px;
        content: '';
        height: 20px;
        position: absolute;
    }
`;
// We could directly export SpeechBubbleStyled but that will stop prop type generation from working.
export const SpeechBubble = (props) => _jsx(SpeechBubbleStyled, Object.assign({}, props));
